import type { ReactNode } from 'react'
import { useCan, useFeature } from '@/hooks/useCan'

/**
 * Conditional rendering by capability.
 *
 *   <Can do="products.create"><Button/></Can>
 *
 * Renders nothing rather than a disabled control: a disabled button the user
 * can never enable is an invitation to ask why, and support has to answer it.
 */
export function Can({
  do: capability,
  feature,
  fallback = null,
  children,
}: {
  do?: string | string[]
  feature?: string
  fallback?: ReactNode
  children: ReactNode
}) {
  const allowed = useCan(capability ?? [])
  const hasFeature = useFeature(feature ?? '')

  if (capability && !allowed) return <>{fallback}</>
  if (feature && !hasFeature) return <>{fallback}</>

  return <>{children}</>
}
